import { render, staticRenderFns } from "./OpenAIRenameModal.vue?vue&type=template&id=2da63846&scoped=true&"
import script from "./OpenAIRenameModal.vue?vue&type=script&lang=js&"
export * from "./OpenAIRenameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da63846",
  null
  
)

export default component.exports